import $ from "jquery";
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils,StorageUtils} from "goingutils";
import departPanelUtils from "../components/departCommon";
import {_dataFromMap} from "../comJs";

class DepartTab extends TabCell {

    constructor(vueObj, goTabs) {
        super();
        let tabCellId="depart";
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = tabCellId;
        this.dataFrom = "depart";
        this.dataFromLabel = "部门";
        this.tabLabel = _dataFromMap[tabCellId];
        this.active = false;
        this.initFirstData = false;
        this.hasSaveGroup = false;
        this.vueObj = vueObj;
        this.hasType=vueObj.hasType;
        this.goTabs = goTabs;
        this.excludeIds=this.goTabs.excludeIds;
    }

    /**
     * 获取左边视图的html代码
     * @param panelHeight
     */
    getLeftCellContent(panelHeight) {
        this.leftTopCellHeight = parseFloat(panelHeight + "") - 40;
        return departPanelUtils.getPanelHeader(this, this.leftTopCellHeight + "px", this.leftTopCellHeight - 5 + "px", "请输入部门名称", this.tabId, false, 160, 210);
    }

    /**
     * 获取右边视图的代码
     * @param panelHeight
     */
    getRightCellContent(panelHeight) {
        return departPanelUtils.initRightCellContent(panelHeight, this, 300);
    }

    loadSysDefData() {
        //如果还未加载过数据 就重新加载 如果加载过了 就不重复加载
        if (!this.initFirstData) {
            if (AssertUtils.isNotEmpty(StorageUtils.getSessionItem("accountId"))) {
                $("#" + this.tabId + "_body")
                    .find(".account_sel .account-change-input").val(StorageUtils.getSessionItem("accountName"));
                //如果缓存了 账套id 则根据账套查询
                this.loadDepartTree({accountId: StorageUtils.getSessionItem("accountId")}, this);
            }
        }
    }

    /**
     * 初始化单位树
     */
    initDepartTree() {
        let cellObj = this;
        //设置树可以进行选择操作
        cellObj.itemConfig["orgSel"] = true;
        cellObj.departTreeObj = departPanelUtils._initDepartTree(cellObj,cellObj.dataFrom,cellObj.dataFromLabel);
    }

    //加载部门树
    loadDepartTree({accountId = ""}, cellObj) {
        departPanelUtils._loadDepartTree({accountId}, cellObj);
    }


    //初始化tabcell的容器控件
    initTabCellCtl() {
        let cellObj = this;
        this.initDepartTree();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), cellObj);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            searchFun: function () {
                cellObj.loadDepartTree({}, cellObj);
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        //初始化控件事件
        this.initCtlEvent();
    }

    searchWaitRecord() {

    }


    //初始化控件事件
    initCtlEvent() {
        this.initIconBtnEvent(this.departTreeObj);
        this.searchAlReadyRecord(this);
    }

    allCheckBoxClick() {
    }

    //选择账套信息
    changeAccountEvent(nodeId, cellObj) {
        if (AssertUtils.isNotEmpty(nodeId)) {
            cellObj.currentAccountId = nodeId;
        }
        cellObj.initFirstData = true;
        cellObj.loadDepartTree({accountId: nodeId}, cellObj);
    }

    /**
     * 销毁组件
     */
    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.departTreeObj != null && AssertUtils.isFunction(this.departTreeObj.destructor)) {
            this.departTreeObj.destructor();
            this.departTreeObj = null;
        }
    }

    /**
     * 移除选中的记录信息
     * @param rId
     * @param dataFrom
     */
    removeSelectedRecord(rId) {
        if(this.departTreeObj.getIndexById(rId)>=0){
            this.departTreeObj.setCheck(rId, false);
        }
    }
}

function initDepartTab(goTabs, vueObj) {
    let departTab = new DepartTab(vueObj, goTabs);
    goTabs.addTabToFactory("depart", departTab);
}

export default initDepartTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/departTab.js